import React from 'react'

export const ProfilePicture = ({
    imageUrl,
}) => {
    return (
        <img
            src={imageUrl}
            alt="Profile Picture"
            style={{ width: '60px', height: "60px", borderRadius: "50px", }}
        />
  )
}
